/**
 * Adding event listeners to the parent window is a tricky subject.
 * Many of our stores add event listeners after some async event occurs.
 * We need to be 100% sure that when Velaro('destroy') is called that
 * all events are cleaned up.
 *
 * This store will keep track of all events registered to the parent
 * window so it can dispose them when Velaro('destroy') is called. It
 * will also prevent listeners from being added once dispose has been
 * called.
 */

export default class ParentWindowEventStore {
  private events: any[] = [];
  disposed: boolean;

  addEventListener(type: any, listener: any) {
    if (this.disposed) {
      return;
    }

    this.events.push({ type, listener });
    window.parent.addEventListener(type, listener);
  }

  removeEventListener(type: any, listener: any) {
    if (this.disposed) {
      return;
    }

    window.parent.removeEventListener(type, listener);

    const index = this.events.findIndex(
      event => event.type === type && event.listener === listener
    );

    this.events.splice(index, 1);
  }

  dispose() {
    this.disposed = true;

    this.events.forEach(event => {
      window.parent.removeEventListener(event.type, event.listener);
    });

    this.events = [];
  }
}
